import {
  selectEpisodeCompliance,
  selectEpisodeProgress,
  selectSessionUserId,
  useAppSelector,
  useFetchEpisodeChaptersQuery,
  useFindPlayerSessionByEpisodeIdQuery,
} from '@/store';
import { Episode, Referrer } from '@/types';

import { EpisodeChapterList as EpisodeChapterListComponent } from './EpisodeChapterList.component';

export const EpisodeChapterList = ({
  episode,
  referrer,
}: {
  episode: Episode;
  referrer: Referrer;
}) => {
  const { episodeId } = episode;

  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, episode?.episodeId),
  );

  const { data: chapters, isLoading: isChaptersLoading } =
    useFetchEpisodeChaptersQuery(
      { episodeId, compliance },
      {
        selectFromResult: result => ({
          ...result,
          data: result.data?.filter(r => !r.isTrailer),
        }),
        skip: !episodeId,
      },
    );

  /*
    Only triggers and signals the initial fetching
    the response data gets pushed to the EntityAdapter and selected via `selectEpisodeProgress`
  */
  const userId = useAppSelector(selectSessionUserId);
  const { isLoading: isUserChapterProgressLoading } =
    useFindPlayerSessionByEpisodeIdQuery(
      { episodeId },
      { skip: !userId || !episodeId, refetchOnMountOrArgChange: true },
    );

  /* Selects the chapter data from the EntityAdapter as it gets continuously updated for e.g. set_position */
  const episodeChaptersProgress = useAppSelector(state =>
    selectEpisodeProgress(state, episodeId),
  );

  if (isChaptersLoading || isUserChapterProgressLoading || !chapters?.length)
    return null;

  return (
    <EpisodeChapterListComponent
      chapters={chapters}
      episodeChaptersProgress={episodeChaptersProgress ?? []}
      referrer={referrer}
    />
  );
};
